import React from "react";
import { AccessTime } from "@mui/icons-material";
import { isValidDate } from "../../utils/datetime";
import { useTranslation } from "react-i18next";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";

const TimePickerField = ({ field, form, ...other }) => {
  const { t } = useTranslation();
  const currentError = form.touched[field.name] && form.errors[field.name];

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        clearable
        name={field.name}
        value={field.value}
        onChange={date => {
          if (!isValidDate(date)) {
            form.setFieldError(field.name, t("validationMessages.validTime"));
          } else {
            form.setFieldError(field.name, "");
          }
          form.setFieldValue(field.name, date, false);
        }}
        keyboardIcon={<AccessTime color="action" />}
        {...other}
        renderInput={params => (
          <TextField
            variant="filled"
            fullWidth
            {...params}
            helperText={currentError}
            error={Boolean(currentError)}
            {...other}
            inputProps={{
              "aria-labelledby": `date-picker-${field.name}`,
              ...params.inputProps,
              ...other.inputProps
            }}
            InputLabelProps={{
              ...other.InputLabelProps,
              id: `date-picker-${field.name}`
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default TimePickerField;
